// global.js
export const ADD_TO_TOAST_QUEUE = 'ADD_TO_TOAST_QUEUE';
export const SET_TOAST_COLOR = 'SET_TOAST_COLOR';
export const SHOW_TOAST = 'SHOW_TOAST';
export const SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE';
export const SET_TOAST_MULTILINE = 'SET_TOAST_MULTILINE';